import { render, staticRenderFns } from "./AddAgenciesToTierAction.vue?vue&type=template&id=dbc96b1e&scoped=true&"
import script from "./AddAgenciesToTierAction.vue?vue&type=script&lang=js&"
export * from "./AddAgenciesToTierAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc96b1e",
  null
  
)

export default component.exports